module.exports = __webpack_public_path__ + "images/0fb71ea9f3c2f50d55b495c7334c94fc.png";


//////////////////
// WEBPACK FOOTER
// ../public/images/sort-icon.png
// module id = 1013
// module chunks = 0